// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-roller {
    display: block;
    margin: 20px auto 10px;
    position: relative;
    width: 64px;
    height: 64px;
}
.lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 32px 32px;
}
.lds-roller div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #b3b3b3;
    margin: -3px 0 0 -3px;
}
.lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
    top: 50px;
    left: 50px;
}
.lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
    top: 54px;
    left: 45px;
}
.lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
    top: 57px;
    left: 39px;
}
.lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
    top: 58px;
    left: 32px;
}
.lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
    top: 57px;
    left: 25px;
}
.lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
    top: 54px;
    left: 19px;
}
.lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
    top: 50px;
    left: 14px;
}
.lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
    top: 45px;
    left: 10px;
}
@keyframes lds-roller {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/loaderSpinner.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,gEAAgE;IAChE,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".lds-roller {\n    display: block;\n    margin: 20px auto 10px;\n    position: relative;\n    width: 64px;\n    height: 64px;\n}\n.lds-roller div {\n    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    transform-origin: 32px 32px;\n}\n.lds-roller div:after {\n    content: \" \";\n    display: block;\n    position: absolute;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #b3b3b3;\n    margin: -3px 0 0 -3px;\n}\n.lds-roller div:nth-child(1) {\n    animation-delay: -0.036s;\n}\n.lds-roller div:nth-child(1):after {\n    top: 50px;\n    left: 50px;\n}\n.lds-roller div:nth-child(2) {\n    animation-delay: -0.072s;\n}\n.lds-roller div:nth-child(2):after {\n    top: 54px;\n    left: 45px;\n}\n.lds-roller div:nth-child(3) {\n    animation-delay: -0.108s;\n}\n.lds-roller div:nth-child(3):after {\n    top: 57px;\n    left: 39px;\n}\n.lds-roller div:nth-child(4) {\n    animation-delay: -0.144s;\n}\n.lds-roller div:nth-child(4):after {\n    top: 58px;\n    left: 32px;\n}\n.lds-roller div:nth-child(5) {\n    animation-delay: -0.18s;\n}\n.lds-roller div:nth-child(5):after {\n    top: 57px;\n    left: 25px;\n}\n.lds-roller div:nth-child(6) {\n    animation-delay: -0.216s;\n}\n.lds-roller div:nth-child(6):after {\n    top: 54px;\n    left: 19px;\n}\n.lds-roller div:nth-child(7) {\n    animation-delay: -0.252s;\n}\n.lds-roller div:nth-child(7):after {\n    top: 50px;\n    left: 14px;\n}\n.lds-roller div:nth-child(8) {\n    animation-delay: -0.288s;\n}\n.lds-roller div:nth-child(8):after {\n    top: 45px;\n    left: 10px;\n}\n@keyframes lds-roller {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
